import axios from '../utils/axios';
import type { LandingPageData } from '../types/index';

export const LANDING_PAGE_REQUEST_TIMEOUT_MS = 30_000;

export async function getLandingPage(
  issuanceId: string,
  index = 0,
  signal?: AbortSignal,
): Promise<LandingPageData | null> {
  const response = await axios.get('/landingpage/data', {
    params: { id: issuanceId, index },
    timeout: LANDING_PAGE_REQUEST_TIMEOUT_MS,
    signal,
  });
  return response.data || null;
}

// Public COA results for the consumer-facing page; the unguessable issuance id is the access control.
export async function getPublicCoaResults(
  issuanceId: string,
  index = 0,
  signal?: AbortSignal,
): Promise<unknown[]> {
  const response = await axios.get('/landingpage/coa-results', {
    params: { id: issuanceId, index },
    timeout: LANDING_PAGE_REQUEST_TIMEOUT_MS,
    signal,
  });
  if (!Array.isArray(response.data)) {
    throw new Error('Invalid COA results response.');
  }
  return response.data;
}
